import type { RecordCardSerial } from '../types';

export const DEFAULT_RECORD_CARD_CONTINUE_TEXT = 'CONTINUER →';

/** Affiche le numéro de série : `4, 12` → `04 / 12`. */
export function formatRecordCardSerialNumber(serial: RecordCardSerial | undefined): string | null {
  if (!serial) return null;
  const n = Math.max(0, Math.floor(serial.n));
  const total = Math.max(0, Math.floor(serial.total));
  const padded = String(n).padStart(2, '0');
  return `${padded} / ${total}`;
}
